import React, { useEffect, useState } from "react";
import "../styles/redeem.css";
import InvestmentHeaderBox1 from "../components/InvestmentHeaderBox1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SelectDropDown from "../components/SelectDropDown";
import { useDispatch, useSelector } from "react-redux";
import { getLocalStorageUserData } from "../utils/userData";
import { swpShow, swpStore } from "../actions/holdingAction";
import { useFormik } from "formik";
import * as Yup from "yup";
import { currentDate } from "../utils/DateFormate";
import PopupModel from "../components/PopupModel";
import successlogo from "../images/popup/success-popup.svg";
import cancel from "../images/popup/alert-image.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import calendarImage from "../images/calendar_month.svg";
import { useRef } from "react";

const SWP = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPopupVisible, setIsPopupVisible] = useState(false); // Manage popup visibility
  const userData = getLocalStorageUserData();
  const { swpShows, swpStores, loading, error } = useSelector(
    (state) => state.holdings
  );
  const dataOfSwp = location?.state?.props;
  const closeModal = () => {
    setIsPopupVisible(false);
  };

  useEffect(() => {
    const payload = {
      product_id: dataOfSwp?.product_id,
      folio_no: dataOfSwp?.folioNumber,
    };
    dispatch(swpShow(payload));
  }, []);

  const formik = useFormik({
    initialValues: {
      // id: userData?.id,
      client_code: swpShows?.data?.client_code,
      scheme_code: swpShows?.data?.product?.scheme_code,
      trans_mode: "P",
      folio_no: swpShows?.data?.folio_no?.toString(),
      internal_ref_number: "",
      start_date: "",
      frequency_type: "",
      // no_of_transfers: "",
      no_of_withdrawals: "",
      installment_amount: Number((dataOfSwp?.current_value || "0").replace(/,/g, "")).toFixed(2),
      first_order_today: "N",
      euin_declaration: "N",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      installment_amount: Yup.string()
        .matches(/^\d+(\.\d+)?$/, "Amount must be a valid number") // Regex to allow only numbers or float values
        .required("Amount is required")
        .typeError("Amount must be a number"),
      start_date: Yup.string()
        .notOneOf(["Select"], "Day is required")
        .required("Day is required"),
      frequency_type: Yup.string()
        .notOneOf(["Select"], "Frequency is required")
        .required("Frequency is required"),
      // no_of_transfers: Yup.number()
      //   .notOneOf(["Select"], "No. of Installations is required")
      //   .typeError("No. of Installations must be a number")
      //   .required("No. of Installations is required")
      //   .min(1, "No. of Installations must be at least 1"),
      no_of_withdrawals: Yup.number()
        .notOneOf(["Select"], "NO. OF WITHDRAWALS is required")
        .typeError("NO. OF WITHDRAWALS must be a number")
        .required("NO. OF WITHDRAWALS is required")
        .min(1, "NO. OF WITHDRAWALS must be at least 1"),
    }),
    onSubmit: (values) => {
          setIsPopupVisible(false);
      dispatch(swpStore(values)).then((response) => {
        if (response) {
          if (response?.status == true) {
            navigate(
              `/orders?order=${
                response?.orderid ? response?.orderid : response?.data?.order
              }`
            );
          } else {
            setIsPopupVisible(true);
          }
        } else {
          setIsPopupVisible(true);
        }
      });
      // setIsPopupVisible(true);
    },
  });
  console.log("dataOfSwp", dataOfSwp);
  const actionPopup = () => {
    navigate("/portfolio");
  };

  const cancelBack = () => {
    formik.resetForm();
    navigate("/portfolio");
  };

  const datePickerRef = useRef(null);

  const handleIconClick = () => {
    // Open the datepicker programmatically
    datePickerRef.current?.setFocus();
  };

  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box">
          <h5 className="mb-4 main-heading-title">
            <Link className="back_icon" to="/portfolio">
              <FontAwesomeIcon icon={faAngleLeft} className="color me-3" />
            </Link>
            SWP
          </h5>
          <InvestmentHeaderBox1 props={dataOfSwp} />

          <div className="card redeam_bottom_card ">
            <div className="card-body p-0">
              <div className="row align-items-center r_inner_section">
                <div className="col-md-2 col-sm-auto my-1">
                  <h6 className="text-muted r_inner_title mb-0">
                    Available units:
                    <span className="fw-bold ms-2">
                      {Number(dataOfSwp?.units.replace(/,/g, "")).toFixed(2)}
                    </span>
                  </h6>
                </div>

                <div className="col-md-1 col-sm-auto px-lg-3 px-0 ">
                  <span className="divider"></span>
                </div>

                <div className="col-md-2 col-sm-auto my-1">
                  <h6 className="text-muted r_inner_title mb-0">
                    Invested Amount:
                    <span className="fw-bold ms-2 ">
                      ₹
                      {Number(
                        (dataOfSwp?.invested_amount || "0").replace(/,/g, "")
                      ).toFixed(2)}
                    </span>
                  </h6>
                </div>

                <div className="col-md-1 col-sm-auto px-lg-3 px-0">
                  <span className="divider"></span>
                </div>

                <div className="col-md-2 col-sm-auto my-1">
                  <h6 className="text-muted r_inner_title mb-0">
                    Current Amount:
                    <span className="fw-bold ms-2 ">
                      ₹{Number((dataOfSwp?.current_value || "0").replace(/,/g, "")).toFixed(2)}
                    </span>
                  </h6>
                </div>

                <div className="col-md-1 col-sm-auto px-lg-3 px-0">
                  <span className="divider"></span>
                </div>

                <div className="col-md-2 col-sm-auto my-1">
                  <h6 className="text-muted r_inner_title mb-0">
                    NAV as on {currentDate()}:
                    <span className="fw-bold ms-2 text_success">
                      ₹{Number(swpShows?.data?.product_nav || 0)?.toFixed(2)}
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="card redeam_bottom_card">
              <div className="row form_body justify-content-center">
                <div className="col-xl-7 col-lg-10 col-md-10 my-2">
                    <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="frequency_type" className="form-label">
                        Frequency
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7 position-relative">
                      <SelectDropDown
                        name="frequency_type"
                        id="frequency_type"
                        value={formik?.values?.frequency_type}
                        changeFunction={(value) => {
                          formik?.setFieldValue("frequency_type", value);
                          // formik?.setFieldValue("no_of_transfers", "");
                        }}
                        options={swpShows?.data?.frequency?.map((label) => ({
                          value: label,
                          label: label,
                        }))}
                      />
                      {formik.errors.frequency_type &&
                        formik.touched.frequency_type && (
                          <div className="text-danger">
                            {formik.errors.frequency_type}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    {parseFloat(dataOfSwp?.current_value?.replace(/,/g, "")) <
                      parseFloat(formik?.values?.installment_amount) && (
                      <div className="col-lg-12 col-md-12 col-sm-12 mb-2">
                        <div className="text-danger mt-2">
                          Installment amount cannot be greater than current
                          value.
                        </div>
                      </div>
                    )}
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="amounttoswp" className="form-label">
                        Amount to SWP
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="amounttoswp"
                        name="installment_amount"
                        placeholder="₹"
                        value={formik.values.installment_amount}
                        
                onChange={(e) => {
  let val = parseInt(e.target.value || "0", 10);

  const result = swpShows?.data?.swp_dates?.find(
    (item) => item.aswp_frequency === formik?.values?.frequency_type
  );

  formik.setFieldValue("installment_amount", e.target.value);

  if (!result) return;

  const SWP_MIN = parseInt(result.aswp_minimum_installment_amount, 10);
  const SWP_MAX = parseInt(result.aswp_maximum_installment_amount, 10);
  const SWP_MULTIPLE = parseInt(result.aswp_multiplier_amount, 10);
  const SWP_MIN_INSTALLMENTS = parseInt(result.aswp_minimum_installment_numbers, 10);
  const SWP_MAX_INSTALLMENTS = parseInt(result.aswp_maximum_installment_numbers, 10);

  // 🔹 Ensure within min and max
  if (val < SWP_MIN) {
    val = SWP_MIN;
  } else if (val > SWP_MAX) {
    val = SWP_MAX;
  }

  // 🔹 Ensure multiple of SWP_MULTIPLE
  if (val % SWP_MULTIPLE !== 0) {
    val = Math.ceil(val / SWP_MULTIPLE) * SWP_MULTIPLE;
  }

  // 🔹 Update installment_amount
 

  // 🔹 Default no. of withdrawals (set minimum if user hasn’t chosen yet)
  let installmentNumbers = formik.values.installment_numbers || SWP_MIN_INSTALLMENTS;

  if (installmentNumbers < SWP_MIN_INSTALLMENTS) {
    installmentNumbers = SWP_MIN_INSTALLMENTS;
  } else if (installmentNumbers > SWP_MAX_INSTALLMENTS) {
    installmentNumbers = SWP_MAX_INSTALLMENTS;
  }

  formik.setFieldValue("installment_numbers", installmentNumbers);

  // 🔹 Calculate total withdrawal = amount × no. of withdrawals
  const withdrawalValue = val * installmentNumbers;
  formik.setFieldValue("no_of_withdrawals", withdrawalValue);
}}
                      />
                      {formik.errors.installment_amount &&
                        formik.touched.installment_amount && (
                          <div className="text-danger">
                            {formik.errors.installment_amount}
                          </div>
                        )}
                    </div>
                  </div>

                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="amounttoswp" className="form-label">
                        No. of withdrawals
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <input
                        type="text"
                        className="form-control"
                        id="no_of_withdrawals"
                        name="no_of_withdrawals"
                        placeholder="Enter No. of withdrawals"
                        value={formik.values.no_of_withdrawals}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.no_of_withdrawals &&
                        formik.touched.no_of_withdrawals && (
                          <div className="text-danger">
                            {formik.errors.no_of_withdrawals}
                          </div>
                        )}
                    </div>
                  </div>

                
                  <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4 mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="day" className="form-label">
                        Start Date
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7 position-relative">
                      {/* <SelectDropDown
                        name="start_date"
                        id="start_date"
                        value={formik?.values?.start_date}
                        changeFunction={(value) =>
                          formik?.setFieldValue("start_date", value)
                        }
                        options={swpShows?.data?.swp_dates?.map((swp_date) => ({
                          value: swp_date,
                          label: swp_date,
                        }))}
                      />
                      {formik.errors.start_date &&
                        formik.touched.start_date && (
                          <div className="text-danger">
                            {formik.errors.start_date}
                          </div>
                        )} */}
                      <DatePicker
                        ref={datePickerRef}
                        className="w-100 form-control"
                        selected={
                          formik?.values?.start_date &&
                          moment(
                            formik?.values?.start_date,
                            "DD/MM/YYYY",
                            true
                          ).isValid()
                            ? moment(
                                formik?.values?.start_date,
                                "DD/MM/YYYY"
                              ).toDate()
                            : null
                        }
                        onChange={(date) => {
                          if (!date || !moment(date).isValid()) return;
                          const formattedDate =
                            moment(date).format("DD/MM/YYYY");
                          formik?.setFieldValue("start_date", formattedDate);
                        }}
                        filterDate={(date) => {
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);
                          const selectedDate = new Date(date);
                          selectedDate.setHours(0, 0, 0, 0);
                          const day = selectedDate.getDate();
                          return (
                            selectedDate >= today &&
                            swpShows?.data?.swp_dates
                              ?.find(
                                (item) =>
                                  item.aswp_frequency ===
                                  formik?.values?.frequency_type
                              )
                              ?.sip_dates_array?.map(Number)
                              .includes(day)
                          );
                        }}
                        disabled={
                          formik?.values?.frequency_type !== "" &&
                          formik?.values?.frequency_type !== "Select"
                            ? false
                            : true
                        }
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        customInput={
                          <input className="form-control" readOnly />
                        }
                      />
                      <img
                        src={calendarImage}
                        alt="Calendar Icon"
                        className="position-absolute imgcal"
                        style={{
                          right: "20px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                        }}
                        onClick={handleIconClick}
                      />
                      {formik.errors.start_date &&
                        formik.touched.start_date && (
                          <div className="text-danger">
                            {formik.errors.start_date}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* <div className="row align-items-center mb-lg-4 mb-md-4 mb-sm-4">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="installations" className="form-label">
                        No. of Installations
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7 position-relative">
                      <SelectDropDown
                        name="no_of_transfers"
                        id="no_of_transfers"
                        value={formik?.values?.no_of_transfers}
                        changeFunction={(value) =>
                          formik?.setFieldValue("no_of_transfers", value)
                        }
                        disabled={
                          formik?.values?.frequency_type != "" &&
                          formik?.values?.frequency_type != "Select"
                            ? false
                            : true
                        }
                        options={swpShows?.data?.swp_dates
                          ?.find(
                            (item) =>
                              item.aswp_frequency ===
                              formik?.values?.frequency_type
                          )
                          ?.tenure?.map((no_of_transfers) => ({
                            value: no_of_transfers,
                            label: no_of_transfers,
                          }))}
                      />
                      {formik.errors.no_of_transfers &&
                        formik.touched.no_of_transfers && (
                          <div className="text-danger">
                            {formik.errors.no_of_transfers}
                          </div>
                        )}
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="card-footer form_card form_card_border">
              <div className="d-flex justify-content-between gap-2">
                <button
                  type="button"
                  onClick={cancelBack}
                  className="form_button "
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={
                    parseFloat(dataOfSwp?.current_value?.replace(/,/g, "")) <
                    parseFloat(formik?.values?.installment_amount)
                      ? true
                      : false
                  }
                  className="form_button next_btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
        {isPopupVisible && swpStores?.status != true && (
          <PopupModel
            id="alertModel"
            title="Lorem Ipsum"
            content={swpStores?.message}
            image={cancel}
            actionPopup={actionPopup}
            closeModal={closeModal}
            btnColor={"btn-success"}
          />
        )}
      </div>
    </div>
  );
};

export default SWP;
